'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').service('FuncoesService', function($http, $q, FuncaoObjectService, RestService) {
  return {
    getModulos: function() {
      const deferred = $q.defer();
      $http.get(`${SERVER + API_VERSION}funcoes/modulos`).then(function(result) {
        deferred.resolve(result.data);
      }, deferred.reject);

      return deferred.promise;
    },

    save: function(funcao) {
      const result = FuncaoObjectService.convertToSend(funcao);
      return result.id ? this.sendUpdate(result) : this.send(result);
    },

    send: function(funcao) {
      return $http({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION}funcoes`,
        data: { funcao: funcao }
      });
    },

    sendUpdate: function(funcao) {
      return $http({
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER + API_VERSION}funcoes/${funcao.id}`,
        data: { funcao: funcao }
      });
    },

    delete: function(id) {
      return $http.delete(`${SERVER + API_VERSION}funcoes/${id}`);
    },

    list: function(filters) {
      const params = !filters ? {} : {
        descricao: filters.descricao || null
      };

      params.simple = true;

      return RestService.getFromUrl(`${SERVER + API_VERSION}funcoes`, params);
    },

    listNoPaginated: function() {
      return RestService.getFromUrl(`${SERVER + API_VERSION}funcoes`, { simple: true });
    },

    get: function(id) {
      const deferred = $q.defer();
      const _this = this;

      $q.all([
        $http.get(`${SERVER + API_VERSION}funcoes/${id}`),
        _this.getModulos()
      ]).then(function(result) {
        const modulos = result[1];
        const funcao = FuncaoObjectService.convertToObject(modulos, result[0].data);
        funcao.itens = modulos.reduce(function(moduleResult, modulo) {
          return moduleResult.concat(modulo.itens);
        }, []);
        deferred.resolve(funcao);
      }, deferred.reject);

      return deferred.promise;
    },

    createObjectFuncao: function() {
      const deferred = $q.defer();

      this.getModulos().then(function(data) {
        const funcao = {
          modulos: data
        };
        funcao.itens = funcao.modulos.reduce(function(result, modulo) {
          return result.concat(modulo.itens);
        }, []);

        deferred.resolve(funcao);
      }, deferred.reject);

      return deferred.promise;
    },

    funcoesNaoClienteAgrogestao: ['safras', 'estadios_fenologicos', 'atividade', 'operacao', 'colheitas', 'pluviometro']
  };
});
